<template>
  <div class="mod-config">
    <div class="detail-container">
      <div class="top-container">
       <div class="detail-img-container">
          <img :src="detailModel.thumbUrl" v-if="detailModel.thumbUrl"/>
          <img src="../../assets/img/logo.png" v-else/>
        </div>
        <div class="right-container">
          <p class="title">{{detailModel.name}}</p>
          <p class="subTitle">{{detailModel.periodInfo}}</p>
          <p class="desc">{{detailModel.content}}</p>
        </div>
      </div>
      <div class="bottom-container">
        <div class="tab-container">
          <el-button
          type="text"
            class="tab-item"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabItemClick(index)"
            style="margin-left: 0px;"
          >
            {{ item }}
            <div class="arrow" v-show="index == currentTabIndex"></div>
          </el-button>
        </div>
        <div
          class="detail-item"
          v-for="(item, index) in tabContentList"
          :key="index"
          v-show="index == currentTabIndex"
        >
          <p class="detail">{{ item }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
  data() {
    return {
      currentToolIndex: 0,
      currentProgressIndex: 0,
      tabList: ["教学策略", "课程目标", "关键词", "课程产品", "课程模块", "课程特色", "课程评价", "课程资源"],
     // tabList: ["教学目标", "教学过程", "教学亮点", "教学反思", "教学评价", "教学资源", "学生反馈"],
      tabContentList: [],
      currentTabIndex: 0,
      detailModel: {},
    };
  },

  created() {
     this.$store.commit("common/updateMenuActiveName", "/course-sample");
    this.getData();
  },

  activated() {
   // this.getData();
  },
  methods: {
    getData() {
      var id = this.$route.query.id;
          this.$http({
            url: this.$http.adornUrl(
              `/business/lessoncase/info/${id}`
            ),
            method: "get",
            params: this.$http.adornParams()
          }).then(({ data }) => {
            if (data && data.code === 0) {
              let dataJson = data.lessonCase
              this.detailModel = dataJson
              this.tabContentList = []
              this.tabContentList.push(dataJson.teachingCategory);
              this.tabContentList.push(dataJson.courseGoal);
              this.tabContentList.push(dataJson.keywords);
              this.tabContentList.push(dataJson.courseProduct);
              this.tabContentList.push(dataJson.courseModule);
              this.tabContentList.push(dataJson.courseFeature);
              this.tabContentList.push(dataJson.courseComment);
              this.tabContentList.push(dataJson.courseResourse);
            }
          });
      },
    tabItemClick(index) {
      this.currentTabIndex = index;
    }
  }
};
</script>
</script>

<style lang="scss" scoped>

  .detail-container {
  padding: 41px 30px;
  .top-container {
    display: flex;
    flex-direction: row;
    .detail-img-container {
      height: 240px;
      width: 33%;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .right-container {
      margin-left: 22px;
      .title {
        font-size: 24px;
        color: #4a4a4a;
        letter-spacing: 0;
        line-height: 24px;
      }
      .subTitle {
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 15px;
      }
      .desc {
        font-size: 12px;
        color: #9b9b9b;
        letter-spacing: 0;
        margin: 31px 0;
        line-height: 18px;
      }
    }
  }
  .bottom-container {
    margin-top: 31px;
    .tab-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .tab-item {
        flex: 1;
        background: #4a90e2;
        border: 1px solid #ffffff;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        padding: 19px 0;
        position: relative;
        .arrow {
          position: absolute;
          width: 28px;
          height: 28px;
          left: calc(50% - 14px);
          bottom: -14px;
          transform: rotate(-45deg);
          background: #4a90e2;
          border-radius: 1px;
          border-radius: 1px;
        }
      }
    }
    .detail-item {
        margin-top: 31px;
      font-size: 12px;
      color: #9b9b9b;
      letter-spacing: 0;
      line-height: 18px;
    }
  }
}
</style>
